import * as React from 'react';

import { ProductLabelModel } from '@notino/react-styleguide';
import { IStock } from '@notino/shared/definitions/custom-definitions';

import { useTagAttributes } from '@components/Universals/ProductItem/useTagAttributes';
import { isDiorBrand } from '@containers/ProductDetailContainer/ProductDetail/utils';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import { FormattedTooltip } from './FormattedTooltip';
import { ITagsProps } from './model';
import { LabelsContainer, LabelWithIcon, StyledLabel } from './styled';

export const Tags: React.FC<ITagsProps> = ({
  type = ProductLabelModel.Types.default,
  onClick,
  customFilter,
  nowrapLg = false,
  ...props
}) => {
  const tagAttributes = useTagAttributes(
    props.attributes as Record<string, unknown>,
    {
      multiple: props?.multiple,
      customFilter,
    }
  );

  const pdCtx = useProductDetailContext(false);
  const isDior = isDiorBrand(pdCtx?.product?.brand?.id);

  if (props.stockAvailability === IStock.outOfStock || !tagAttributes) {
    return null;
  }

  return (
    <LabelsContainer noWrapLg={nowrapLg}>
      {tagAttributes.map(
        ({ style, icon, tooltipMessage, label, attribute }) => (
          <FormattedTooltip
            key={label}
            wrapperEnabled={
              !props.small &&
              type === ProductLabelModel.Types.default &&
              !!tooltipMessage
            }
            tooltipMessage={tooltipMessage!}
          >
            <StyledLabel
              onClick={() => onClick?.(attribute)}
              key={label}
              labelStyle={
                isDior ? ProductLabelModel.ProductStyles.neutral : style
              }
              icon={icon}
              labelType={type}
              className={`pd-variant-tag-${label}`}
            >
              <LabelWithIcon>
                {icon} {label}
              </LabelWithIcon>
            </StyledLabel>
          </FormattedTooltip>
        )
      )}
    </LabelsContainer>
  );
};
